<div class="container-fluid p-0">
    <div class="row"> 
      <div class="col">
        <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped" [value]="BankTransformer"
          [selectionMode]="'single'" [rows]="20" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[20,25,30]">
          <p-column field="serial" header="{{ 'SERIAL' | translate }}" [sortable]="true"></p-column>
          <p-column header="{{ 'TRANSTYPE' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <div>
                {{translate.currentLang == 'ar'
                ? row.transTypeNameAr:
                row.transTypeNameEn}}
              </div>
            </ng-template>
          </p-column>
          <p-column header="{{ 'TRANSFORMERTYPE' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <div>
                {{translate.currentLang == 'ar'
                ? row.transFormerTypeNameAr:
                row.transFormerTypeNameEn}}
              </div>
            </ng-template>
          </p-column>
          <p-column header="{{ 'TRANSFROM' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <div>
                {{translate.currentLang == 'ar'
                ? row.transFromNameAr:
                row.transFromNameEn}}
              </div>
            </ng-template>
          </p-column>
          <p-column header="{{ 'TRANSTO' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <div>
                {{translate.currentLang == 'ar'
                ? row.transToNameAr:
                row.transToNameEn}}
              </div>
            </ng-template>
          </p-column>
          <p-column header="{{ 'TRANCEDATE' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <div>
                {{row.transDate|date:'dd-MM-yyyy'}}
              </div>
            </ng-template>
          </p-column>
          <p-column field="value" header="{{ 'VALUE' | translate }}" [sortable]="true"></p-column>
          
          <p-column header="{{ 'DISCOUNT' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <div>
                <input numbersOnly class="form-control form-control-sm"  (change)="OncurrentValueChange(row)" [(ngModel)]="row.payedValue" />
              </div>
            </ng-template>
          </p-column>
          <p-column header="{{ 'RemainingPrice' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              <input  [attr.disabled]="true" numbersOnly class="form-control form-control-sm"  [(ngModel)]="row.remainingValue" />
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <btns-ctrl [appCodes]="[1]"  (clicked)="save()"></btns-ctrl>
      </div>
    </div>
  </div>